// Libraries
import React from 'react'
import PropTypes from 'prop-types'

// PropTypes and DefaultProps
const defaultProps = {
  width: '32px',
  height: '32px',
  color: '',
}

const propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string,
}

// Component
function IconNotificationPayment({ width, height }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 39 43.69"
    >
      <g transform="translate(0 4.69)">
        <circle fill="#2a428c" cx="19.5" cy="19.5" r="19.5" />
        <g transform="translate(1.228 -4.69)">
          <g transform="translate(0 27.131)">
            <path
              fill="#0091c8"
              d="M109.191,322.6H85.034a3.272,3.272,0,1,1,0-6.545h24.156a3.272,3.272,0,1,1,0,6.545Z"
              transform="translate(-81.762 -316.052)"
            />
          </g>
          <g transform="translate(19.467 0)">
            <path
              fill="#d3dcfb"
              d="M283.895,62.472l1.684-1.684,1.684,1.684,1.684-1.684.092.092V52.786a4.025,4.025,0,0,0-4.025-4.025H273.545v13.99h6.7l1.963-1.963Z"
              transform="translate(-273.545 -48.761)"
            />
          </g>
          <g transform="translate(19.467)">
            <path
              fill="#bec8f7"
              d="M280.247,62.751l1.963-1.963,1.038,1.038v-9.04a4.026,4.026,0,0,1,2.9-3.863,4.025,4.025,0,0,0-1.13-.162H273.545v13.99h6.7Z"
              transform="translate(-273.545 -48.761)"
            />
          </g>
          <g transform="translate(2.931 29.424)">
            <path
              fill="#0073aa"
              d="M134.385,340.76H111.7a1.06,1.06,0,0,1,0-2.121h22.684a1.06,1.06,0,1,1,0,2.121Z"
              transform="translate(-110.64 -338.639)"
            />
          </g>
          <g transform="translate(3.991 0)">
            <path
              fill="#e8f4fc"
              d="M147.795,48.761H125.11a4.025,4.025,0,0,0-4.025,4.025V79.245h22.684V52.786a4.025,4.025,0,0,1,4.025-4.025Z"
              transform="translate(-121.085 -48.761)"
            />
          </g>
          <g transform="translate(3.991 0)">
            <path
              fill="#d3dcfb"
              d="M128.354,48.761H125.11a4.025,4.025,0,0,0-4.025,4.025V79.245h3.243V52.786A4.025,4.025,0,0,1,128.354,48.761Z"
              transform="translate(-121.085 -48.761)"
            />
          </g>
          <g transform="translate(7.235 6.924)">
            <path
              fill="#bec8f7"
              d="M153.039,116.971h9.24V119.1h-9.24Z"
              transform="translate(-153.039 -116.971)"
            />
          </g>
          <g transform="translate(20.257 6.924)">
            <path
              fill="#73c3f9"
              d="M281.331,116.971h3.245V119.1h-3.245Z"
              transform="translate(-281.331 -116.971)"
            />
          </g>
          <g transform="translate(7.235 12.724)">
            <path
              fill="#bec8f7"
              d="M153.039,174.113h9.24v2.125h-9.24Z"
              transform="translate(-153.039 -174.113)"
            />
          </g>
          <g transform="translate(20.257 12.724)">
            <path
              fill="#73c3f9"
              d="M281.331,174.113h3.245v2.125h-3.245Z"
              transform="translate(-281.331 -174.113)"
            />
          </g>
          <g transform="translate(7.235 18.701)">
            <path
              fill="#bec8f7"
              d="M153.039,233h9.24v2.125h-9.24Z"
              transform="translate(-153.039 -232.999)"
            />
          </g>
          <g transform="translate(20.257 18.701)">
            <path
              fill="#73c3f9"
              d="M281.331,233h3.245v2.125h-3.245Z"
              transform="translate(-281.331 -232.999)"
            />
          </g>
        </g>
        <g transform="translate(13.218 23.469)">
          <g transform="translate(0)">
            <path
              fill="#5d913f"
              d="M173.526,308.107h20.451V318H173.526Z"
              transform="translate(-173.526 -308.107)"
            />
          </g>
          <g transform="translate(0)">
            <path
              fill="#3d772a"
              d="M192.783,309.3v7.5H174.72v-7.5Zm1.194-1.194H173.526V318h20.451Z"
              transform="translate(-173.526 -308.107)"
            />
          </g>
          <path
            fill="#3d772a"
            d="M173.525,310.918a2.013,2.013,0,0,0,2.8-2.811h-2.8v2.811Z"
            transform="translate(-173.525 -308.107)"
          />
          <g transform="translate(0 6.749)">
            <path
              fill="#3d772a"
              d="M174.678,396.706a2,2,0,0,0-1.152.363v2.781h2.819a2.014,2.014,0,0,0-1.667-3.143Z"
              transform="translate(-173.526 -396.706)"
            />
          </g>
          <g transform="translate(17.067 0)">
            <path
              fill="#3d772a"
              d="M397.588,309.267a2.013,2.013,0,0,0,3.384,1.475v-2.635h-3.016A2,2,0,0,0,397.588,309.267Z"
              transform="translate(-397.588 -308.107)"
            />
          </g>
          <g transform="translate(17.067 6.749)">
            <path
              fill="#3d772a"
              d="M400.972,397.243a2.014,2.014,0,0,0-3.037,2.6h3.037Z"
              transform="translate(-397.588 -396.705)"
            />
          </g>
          <g transform="translate(6.864 1.584)">
            <circle fill="#3d772a" cx="3.362" cy="3.362" r="3.362" />
          </g>
          <g transform="translate(2.049 4.309)">
            <path
              fill="#6eaa50"
              d="M200.42,364.679h3.863v1.273H200.42Z"
              transform="translate(-200.42 -364.679)"
            />
          </g>
          <g transform="translate(14.545 4.309)">
            <path
              fill="#6eaa50"
              d="M364.469,364.679h3.863v1.273h-3.863Z"
              transform="translate(-364.469 -364.679)"
            />
          </g>
          <g transform="translate(9.05 2.73)">
            <path
              fill="#6eaa50"
              d="M293.28,347.956a2.313,2.313,0,0,1-.933-.206v-.808l.537-.038v.315c0,.1.016.136.108.168a.891.891,0,0,0,.288.043v-1.015c-.5-.136-.949-.347-.949-.977a.989.989,0,0,1,.949-.988v-.5h.407v.488a2.257,2.257,0,0,1,.841.206v.765l-.532.033v-.293c0-.1-.016-.136-.108-.168a1.1,1.1,0,0,0-.2-.038v.955h.005c.477.147.977.358.977,1.015a1.026,1.026,0,0,1-.982,1.025v.559h-.407Zm0-2.2v-.781a.388.388,0,0,0-.282.4A.4.4,0,0,0,293.28,345.758Zm.407.787v.846a.426.426,0,0,0,.309-.45A.415.415,0,0,0,293.687,346.545Z"
              transform="translate(-292.331 -343.951)"
            />
          </g>
        </g>
        <g transform="translate(15.906 26.084)">
          <g transform="translate(0 0)">
            <path
              fill="#97d729"
              d="M208.819,342.432H229.27v9.892H208.819Z"
              transform="translate(-208.819 -342.432)"
            />
          </g>
          <g transform="translate(0)">
            <path
              fill="#6eaa50"
              d="M228.076,343.626v7.5H210.013v-7.5Zm1.194-1.194H208.819v9.892H229.27Z"
              transform="translate(-208.819 -342.432)"
            />
          </g>
          <g transform="translate(0 0)">
            <path
              fill="#6eaa50"
              d="M208.818,345.243a2.013,2.013,0,0,0,2.8-2.811h-2.8v2.811Z"
              transform="translate(-208.818 -342.432)"
            />
          </g>
          <g transform="translate(0 6.749)">
            <path
              fill="#6eaa50"
              d="M209.971,431.03a2,2,0,0,0-1.152.363v2.781h2.819a2.014,2.014,0,0,0-1.667-3.143Z"
              transform="translate(-208.819 -431.03)"
            />
          </g>
          <g transform="translate(17.067 0)">
            <path
              fill="#6eaa50"
              d="M432.881,343.592a2.013,2.013,0,0,0,3.384,1.475v-2.635h-3.016A2,2,0,0,0,432.881,343.592Z"
              transform="translate(-432.881 -342.432)"
            />
          </g>
          <g transform="translate(17.067 6.749)">
            <path
              fill="#6eaa50"
              d="M436.265,431.568a2.014,2.014,0,0,0-3.037,2.6h3.037Z"
              transform="translate(-432.881 -431.03)"
            />
          </g>
          <g transform="translate(6.864 1.584)">
            <circle fill="#6eaa50" cx="3.362" cy="3.362" r="3.362" />
          </g>
          <g transform="translate(2.049 4.309)">
            <path
              fill="#8bc727"
              d="M235.713,399h3.863v1.273h-3.863Z"
              transform="translate(-235.713 -399.004)"
            />
          </g>
          <g transform="translate(14.545 4.309)">
            <path
              fill="#8bc727"
              d="M399.762,399h3.863v1.273h-3.863Z"
              transform="translate(-399.762 -399.004)"
            />
          </g>
        </g>
        <g transform="translate(3.001 26.225)">
          <g transform="translate(0)">
            <circle fill="#fee45a" cx="5.607" cy="5.607" r="5.607" />
          </g>
          <g transform="translate(1.146 1.146)">
            <path
              fill="#ffd23c"
              d="M55.29,404.984a4.461,4.461,0,0,1,4.442,4.063c.012-.131.019-.264.019-.4a4.461,4.461,0,0,0-8.922,0c0,.134.007.267.019.4A4.461,4.461,0,0,1,55.29,404.984Z"
              transform="translate(-50.829 -404.187)"
            />
          </g>
          <path
            fill="#faf58c"
            d="M45,393.947a4.412,4.412,0,1,1-4.412,4.412A4.417,4.417,0,0,1,45,393.947m0-1.195a5.607,5.607,0,1,0,5.607,5.607A5.607,5.607,0,0,0,45,392.752Z"
            transform="translate(-39.394 -392.752)"
          />
        </g>
      </g>
    </svg>
  )
}

IconNotificationPayment.defaultProps = defaultProps
IconNotificationPayment.propTypes = propTypes

export default IconNotificationPayment
